import {toast} from 'react-semantic-toasts';
import React from 'react';
import {List} from 'semantic-ui-react';
import {toJson} from './request';

/**
 * Show a success toast.
 *
 * @param {Object} props Extra props to pass to toast.
 */
export function success(props = {}) {
    if (typeof props === 'string') {
        props = {description: props};
    }

    return toast({
        type: 'success',
        animation: 'slide down',
        time: 4000,
        ...props,
    });
}

async function getErrors(props) {
    const errors = props?.errors ?? [];

    if (typeof props?.response === 'object' && props.response?.constructor?.name === 'Response') {
        const res = await toJson(props.response);

        if (res.validationErrors && res.validationErrors.length > 0) {
            res.validationErrors.forEach(err => errors.push(err));
        }
    }

    let customErrors = errors?.filter(e => e.propertyName === 'custom') ?? [];

    customErrors = customErrors.map(error => {
        if (error?.errorMessage?.slice(error?.errorMessage?.length - 1) !== '.') {
            error.errorMessage = `${error.errorMessage}.`;
        }

        return error;
    });

    return customErrors;
}

/**
 * @typedef {Object} Error
 * @property {string} propertyName - field name or 'custom' for generic list
 * @property {string} errorMessage 
 */

/**
 * @typedef {Object} ErrorProps
 * @property {string} description
 * @property {Array<Error>} errors
 */

/**
 * Show an error toast.
 *
 * @param {ErrorProps | Object | string} props Extra props to pass to toast.
 */
export function error(props = {}) {
    if (typeof props === 'string') {
        props = { description: props };
    }

    getErrors(props).then(customErrors => {
        const hasErrors = customErrors?.length > 0;

        if (hasErrors) {
            let ogMsg = props.description;
            if (ogMsg?.slice(ogMsg?.length - 1) !== '.') {
                ogMsg = `${ogMsg}.`;
            }

            props.description = <>
                {ogMsg}
                <List>
                    {customErrors.map((error, i) => <List.Item
                        className="customError"
                        key={i}
                    >{error.errorMessage}</List.Item>)}
                </List>
            </>;
        }

        return toast({
            type: 'error',
            animation: 'slide down',
            time: hasErrors ? 0 : 10000,
            ...props,
        });
    }).catch(() => {
        return toast({
            type: 'error',
            animation: 'slide down',
            time: 10000,
            ...props,
        });
    })
}
